import PropTypes from "prop-types";
import React from "react";

/**
 * Anchor renders children that will be used to "anchor" other elements - elements that will be
 * positioned adjacent to the children prop. AnchorTarget will be used to render the adjacent element.
 * Anchor and AnchorTarget must be used together.
 *
 * NOTE:
 * A classname must be given which contains an anchor-name property. This should be something like:
 *
 * .classPassedToAnchor {
 *    anchor-name: --my-anchor;
 *  }
 *
 * AnchorTarget, used alongside Anchor, should also refer to this name. See AnchorTarget for info.
 *
 * TODO:
 * The className with anchor-name requirement is temporary until browser support is widely
 * implemented. This requirement can then go away with PHX-2817.
 */

export const Anchor = (props) => {
  const { children, className, name } = props;

  return (
    <div className={className} style={getStyle()}>
      {children}
    </div>
  );

  function getStyle() {
    return {
      anchorName: `--${name}`,
    };
  }
};

Anchor.propTypes = {
  /**
   * Content that use to position AnchorTarget.
   *
   * For example:
   * <Anchor className={styles.anchor} name="my-name">Anchor</Anchor>
   * <AnchorTarget className={styles.target} location="right" name="my-name">Target</AnchorTarget>
   */
  children: PropTypes.node.isRequired,

  /**
   * Additional classes for positioning the component. It must contain a anchor-name property.
   * Something like:
   * anchor-name: --my-anchor;
   */
  className: PropTypes.string.isRequired,

  /**
   * Name that will be used to tie Anchor and AnchorTarget together. Both Anchor and AnchorTarget
   * must receive the same name prop value.
   */
  name: PropTypes.string.isRequired,
};
